import "./subscriptioncompleted.scss";
import React, { useEffect, useState } from "react";
import Home from "../../Pages/Logged/Home";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { Button } from "react-bootstrap";
import { useLocation } from "react-router";
import { useNavigate } from "react-router-dom";

const SubscriptionCompleted = (props) => {
  const [subscriptionId, setSubscriptionId] = useState(null);
  const location = useLocation();
  let navigate = useNavigate();

  useEffect(() => {
    if (location?.state?.subscriptionId) {
      setSubscriptionId(location?.state?.subscriptionId);
    }
  }, [location?.state?.subscriptionId]);

  const handleGetStarted = () => {
    return navigate("/", { replace: false });
  };

  return (
    <div className={`subscriptioncompleted-container ${props.selectPlan ? `select-plan` : ``}`}>
      {subscriptionId && (
        <>
          <div className="success-container">
            <FontAwesomeIcon style={{ color: "#3FDD78", fontSize: "128px" }} icon={faCheckCircle} />
            <span className="success-title">Thank you for your purchase!</span>
            <span className="success-message text-muted">
              Your order has been received and is currently being processed. You will receive an email confirmation with your order details shortly.
            </span>

            <div className="success-buttons">
              <Button variant="dark" type="button" onClick={handleGetStarted}>
                Manage Subscription
              </Button>
            </div>
          </div>
          <div className="home">
            <Home hideTitle={true} />
          </div>
        </>
      )}
    </div>
  );
};
export default SubscriptionCompleted;
